import Abstract from "../../../../abstract-view/abstract.js";
export default class Insert extends Abstract {
  constructor(element, index) {
    super();

    this._element = element;
    this._index = index;

    this._linkElement = null;
    this._titleButtonElement = null;
    this._buttonElement = null;

    this._linkClickHandler = this._linkClickHandler.bind(this);
    this._titleButtonClickHandler = this._titleButtonClickHandler.bind(this);
    this._buttonClickHandler = this._buttonClickHandler.bind(this);
    this._quizButtonClickHandler = this._quizButtonClickHandler.bind(this);
  }

  getLinkElement() {
    if (!this._linkElement) {
      this._linkElement = this._element.querySelector(`.category-insertion-link`);
    }

    return this._linkElement;
  }

  getButtonElement() {
    if (!this._buttonElement) {
      this._buttonElement = this._element.querySelector(`.button_category-insertion`);
    }

    return this._buttonElement;
  }

  getTitleButtonElement() {
    if (!this._titleButtonElement) {
      this._titleButtonElement = this._element.querySelector(`.category-insertion__title`);
    }

    return this._titleButtonElement;
  }

  getHref() {
    return this.getLinkElement().href;
  }

  getId() {
    return +this._element.dataset.insertId;
  }

  getType() {
    return this._element.dataset.type;
  }

  setLinkClickHandler(callback) {
    this._callback.linkClick = callback;
    this.getLinkElement().addEventListener(`click`, this._linkClickHandler);
  }

  setTitleButtonClickHandler(callback) {
    this._callback.titleButtonClick = callback;
    this.getTitleButtonElement().addEventListener(`click`, this._titleButtonClickHandler);
  }

  setButtonClickHandler(callback) {
    this._callback.buttonClick = callback;
    this.getButtonElement().addEventListener(`click`, this._buttonClickHandler);
  }

  setQuizButtonClickHandler(callback) {
    this._callback.quizButtonClick = callback;

    if (this.getButtonElement()) {
      this.getButtonElement().addEventListener(`click`, this._quizButtonClickHandler);
    }
  }

  removeLinkClickHandler() {
    this._callback.linkClick = null;
    this.getLinkElement().removeEventListener(`click`, this._linkClickHandler);
  }

  removeTitleButtonClickHandler() {
    this._callback.titleButtonClick = null;
    this.getTitleButtonElement().removeEventListener(`click`, this._titleButtonClickHandler);
  }

  removeButtonClickHandler() {
    this._callback.buttonClick = null;
    this.getButtonElement().removeEventListener(`click`, this._buttonClickHandler);
  }

  removeQuizButtonClickHandler(callback)  {
    this._callback.quizButtonClick = null;
    this.getButtonElement().removeEventListener(`click`, this._quizButtonClickHandler);
  }

  _linkClickHandler(evt) {
    this._callback.linkClick(evt, this._index);
  }

  _titleButtonClickHandler() {
    this._callback.titleButtonClick(this._index);
  }

  _buttonClickHandler() {
    this._callback.buttonClick(this._index);
  }

  _quizButtonClickHandler() {
    this._callback.quizButtonClick();
  }
}
